import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { TrustRow } from '../TrustRow';
import { finalRecap, MOCKUP_URL } from '../../data/offer';
export function FinalCta() {
  return <section className="bg-navy-950 px-5 py-16 text-white sm:py-20" aria-labelledby="final-title" data-id="element-161" data-mp="1so2saj0c2iaz">
      <div className="mx-auto max-w-5xl" data-id="element-162" data-mp="1eobae76p4hrp">
        <h2 id="final-title" className="text-center font-display text-[28px] font-black uppercase leading-[1.05] sm:text-4xl lg:text-5xl" data-id="element-163" data-mp="1en8m870rctfh">
          Make maxillary growth assessment easier to <span className="text-gold" data-id="element-164" data-mp="14qx4v2mb9de6">study, organize, and understand.</span>
        </h2>
        <p className="mt-4 text-center font-display text-sm font-extrabold uppercase text-electric-light sm:text-base" data-id="element-165" data-mp="19oou1ovkmleo">
          One clinical roadmap. Six specialized volumes. Five practical bonuses.
        </p>

        <div className="mt-10 grid items-center gap-8 md:grid-cols-2" data-id="element-166" data-mp="343hmjf15qw2e">
          <div className="rounded-3xl bg-white p-4" data-id="element-167" data-mp="28v5a9cprsi9">
            <img src={MOCKUP_URL} alt="Maxillary Growth Blueprint complete collection" className="w-full" loading="lazy" data-id="element-168" data-mp="27k2abr3eos7" />
          </div>
          <div data-id="element-169" data-mp="b1f5vfckg75q">
            <p className="text-lg text-white/80" data-id="element-170" data-mp="b1yeu6k8nl7m">You don’t need another collection of disconnected notes.</p>
            <p className="mt-2 text-lg font-semibold" data-id="element-171" data-mp="6zl8bfxo3j9s">
              You need a structured way to study the essential concepts behind craniofacial growth assessment and
              dentofacial orthopedic planning.
            </p>
            <ul className="mt-6 space-y-3" data-id="element-172" data-mp="3ai4t5xe0nmuk">
              {finalRecap.map(item => <li key={item} className="flex gap-3 text-base font-medium" data-id="element-173" data-mp="3oh4g90lvrtom">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-174" data-mp="3jgyv83a495fi" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-5 font-display text-lg font-black uppercase text-gold" data-id="element-175" data-mp="yr9fzp5i3hma">Plus 5 exclusive clinical bonuses.</p>
          </div>
        </div>

        <div className="mx-auto mt-12 flex max-w-xl flex-col items-center gap-6 text-center" data-id="element-176" data-mp="3sipoesxlfdqw">
          <div data-id="element-177" data-mp="1b4sshkxvmxo">
            <p className="text-sm font-semibold uppercase text-white/60" data-id="element-178" data-mp="1esljeik85bc">
              Total illustrative reference value: <s data-id="element-179" data-mp="5cgnh1io6ycq">$205</s>
            </p>
            <p className="mt-1 font-display text-3xl font-black uppercase leading-tight sm:text-4xl" data-id="element-180" data-mp="admcopd4g3hi">
              Get everything for just <span className="text-gold" data-id="element-181" data-mp="39u2m2i6sx2h0">$27 USD</span>
            </p>
          </div>
          <CtaButton label="Yes! I want Maxillary Growth Blueprint™" data-id="element-182" data-mp="3duw8t88icb8b" />
          <Countdown tone="dark" data-id="element-183" data-mp="3isnyrwpldn9v" />
          <TrustRow tone="dark" data-id="element-184" data-mp="3irmohugeh4t7" />
          <p className="font-display text-lg font-bold leading-snug text-white" data-id="element-185" data-mp="3ircvrz3z0jjt">
            Stop studying growth concepts in isolation.{' '}
            <span className="text-electric-light" data-id="element-186" data-mp="2q3h2l4dm19rs">Start connecting them through a structured clinical roadmap.</span>
          </p>
        </div>
      </div>
    </section>;
}